import { createContext } from "react";

const ChangesContext = createContext({});

export default ChangesContext;
